/*jshint -W065 */
/* eslint-disable indent */
import React from 'react';
import _get from 'lodash.get';
import {
    Button,
    Checkbox,
    FormControlLabel,
    FormGroup,
    Grid,
    Paper,
    Typography,
    withStyles,
} from 'material-ui';
import Tooltip from 'material-ui/Tooltip';
import { LinearProgress } from 'material-ui/Progress';
import 'react-virtualized/styles.css';
import currencyFormatter from 'currency-formatter';
import ReservationPricesRender from './ReservationPricesRender';
import ReservationDetailsRender from './ReservationDetailsRender';
import ReservationHolderRender from './ReservationHolderRender';
import InformationPanel from '../../ui/InformationPanel';
import HotelHeaderRender from './HotelHeaderRender';
import OLYWebPageComponent from '../OLYWebPageComponent';
import { doReservation, getPaymentToken, errorPayment, cancelPaymentForReservation } from '../Reservations/reservationsServices';
import { getDefaultValues, getValidator } from './Validators/ClientLocatorFactory';
import { translate } from 'react-i18next';
import { netPrice } from '../../defaultValues/netPrice';
import getValue from '../../defaultValues/getValue';
import ReservationFlightRender from './Flight/ReservationFlightRender';
import moment from 'moment';
import { DoRender} from '../Utils/shared';
import DynIcon from '../Utils/DynIcon';
import ValidateSpanishID from '../Utils/validate_spanish_id';
import { connect } from 'react-redux';
import { setObservations } from '../../actions/hotelsActions';
import { trackEvent } from '../../services/gaService';

const styles = theme => ({
    root: {
        backgroundColor: '#F5F5F5',
        margin: '0 auto',
        marginBottom: '48px',
        fontWeight: '300 !important',
    },
    gridContainer: {
        maxWidth: '1024',
        margin: '0 auto',
    },
    photoIcon: {
        fill: '#dfdfdf',
        width: '196px',
        height: '100%',
        paddingLeft: '1em',
    },
    paper: {
        padding: '3rem',
    },
    expandedButton: {
        minHeight: '60px',
        minWidth: '192px',
        margin: '0 auto',
        fontSize: '24px',
        fontWeight: '300',
    },
    expandIcon: {
        color: theme.palette.primary.main
    },
    bookingTitle: {
        color: theme.palette.primary.main,
        padding: '20px 0 20px 25px',
        fontWeight: 'bold',
        fontSize: '1.2rem'
    },
    paperFrame: {
        margin: '40px 0px 20px 0px'
    }
});

function formatPrice(value) {
    return currencyFormatter.format(value, { code: 'EUR' });
}

function renderCancellations(pos, cancelGroup, pvpFlag, netFlag, props) {
    if (cancelGroup) {
        return cancelGroup.map(cancel => (
            <li>
                {props.t('CONFIRM_BOOKING.BOOKING_CANCEL_TEXT_PRE') + ' '}<b>{cancel.date}</b>{' ' + props.t('CONFIRM_BOOKING.BOOKING_CANCEL_TEXT_POST') + ' '} &nbsp;
                {
                    pvpFlag ?
                        <Tooltip id="tooltip-icon" title={netFlag ? props.t('BOOKINGS.NET') + ': ' + formatPrice(cancel.cost) : ''}>
                            <b>{formatPrice(cancel.pvpCost)}</b>
                        </Tooltip>
                        :
                        <b>{formatPrice(cancel.cost)}</b>
                }
            </li>
        ));
    } else {
        return '';
    }
}

function renderTerms(services) {
    if (services) {
        let terms = String(services).split(/[\r\n]+/);
        terms.map(t => t = String(t).trim());
        terms = terms.filter(t => t != '');
        terms.map(t => t += '<br />');
        return terms.map(t => <p>{t}</p>);
    }
    else {
        return '';
    }
}

function renderTOC(terms) {
    if (terms && terms.length > 0) {
        terms = terms.filter(room => room.observations !== '' || room.restrictions !== '' || room.alerts !== '');
        return terms.map(room => {
            return (
                <Typography variant="body1">
                    <b>{room.services}</b>
                    <ul>{renderTerms(room.observations)}</ul>
                    <ul>{renderTerms(room.restrictions)}</ul>
                    <ul>{renderTerms(room.alerts)}</ul>
                    <br />
                </Typography>
            );
        });
    }
}

export class PaymentIframe extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
        };
        this.btnRef = React.createRef();
        this.iframeRef = React.createRef();
    }

    componentDidMount() {
        this.btnRef.current.click();
    }
    render() {
        const url = process.env.REACT_APP_UNIVERSAL_PAY_IFRAME_URL;
        const { token, t } = this.props;

        return (
            <div style={{ width: '100%', height: '100%', padding: 0 }}>
                <p style={{fontSize: '1.1em', textAlign: 'center'}}><strong>{t('CONFIRM_MODIFY_BOOKING.CONTACT_INFO')}</strong></p>
                {this.state.loading ?
                    <div>
                        <Typography>{t('COMMON.LOADING_PAYMENT_GATEWAY')}</Typography>
                        <LinearProgress />
                    </div>
                    : ''}
                <iframe title="payment-iframe" scrolling="no"
                    onError={(e) => { this.setState({ loading: false }); }}
                    onLoad={(e) => { this.setState({ loading: false }); }}
                    style={{ width: '100%', height: '100%', border: 0, padding: 0 }} ref={this.iframeRef} name="ventana"></iframe>
                <form name="pagoForm" action={url} target="ventana" method="post">
                    <input type="hidden" name="TOKEN" value={token} />
                    <button hidden ref={this.btnRef} type="submit">submit</button>
                </form>
            </div>
        );
    }
}

class ReservationConfirmView extends OLYWebPageComponent {

    constructor(props) {
        super(props);
        this.pageTitle = props.t('PAGE_TITLES.ReservationSummary');
        this.pageName = 'ReservationSummary';
        this.pageReference =
            'https://xcaleconsulting.atlassian.net/wiki/spaces/OL/pages/630947898/UI+-+Confirmaci+n+Reserva';

        this.clientLocatorValidator = getValidator(this.currentUser.accountName);
        const defaultvalues = getDefaultValues(this.currentUser.accountName);

        this.state = {
            iframeToken: null,
            merchantOperation: null,
            hotel: {},
            reservationRequest: JSON.parse(localStorage.getItem('valuationRequest')),
            expanded: false,
            aceptoreservar: false,
            formClientLocatorError: defaultvalues.validateClientLocator,
            formClientLocatorErrorMessage: defaultvalues.errorMessageClientLocator,
            formHolderError: true,
            processing: false,
            completed: 0,
            operationstatus: 'info',
            hideIcon: false,
            mode: 'indeterminate',
            operationtext: '',
            operationtitle: this.props.t('CONFIRM_BOOKING.PLEASE_WAIT'),
            B2bVerPVP: this.currentUser.authorities.includes('B2bVerPVP'),
            observationsChecks: [
                { value: 2, checked: false, label: 'CONFIRM_BOOKING.DOBLE_BED' },
                { value: 3, checked: false, label: 'CONFIRM_BOOKING.TWO_BEDS' },
                { value: 4, checked: false, label: 'CONFIRM_BOOKING.TOP_FLOOR' },
                { value: 5, checked: false, label: 'CONFIRM_BOOKING.GROUND_FLOOR' },
                { value: 6, checked: false, label: 'CONFIRM_BOOKING.CLIENT_WHITOUT_VOUCHER' },
                { value: 7, checked: false, label: 'CONFIRM_BOOKING.LATE_ARRIVAL' },
                { value: 10, checked: false, label: 'CONFIRM_BOOKING.COT' },
                { value: 8, checked: false, label: 'CONFIRM_BOOKING.ADJOINING_ROOMS' },
                { value: 9, checked: false, label: 'CONFIRM_BOOKING.INTERCONNECTING_ROOMS' }
            ]
        };

        this.state.reservationRequest === null ? (this.state.reservationRequest = {}) : this.state.reservationRequest;

        this.state.reservationRequest.valuationResult = JSON.parse(localStorage.getItem('valuationResult'));

        this.state.reservationRequest.price = this.state.reservationRequest.valuationResult.price;
        this.state.reservationRequest.pvp = this.state.reservationRequest.valuationResult.pvp;
        this.state.hotel = this.state.reservationRequest.valuationResult.hotels[0];
        if (this.state.reservationRequest.valuationResult.flightDataRequired) {
            let flightStartDay = moment(this.state.reservationRequest.checkInDate, 'DD/MM/YYYY');
            let flightEndDay = flightStartDay.clone();
            //flightStartDay.add(-1, 'days');
            this.state.reservationRequest.valuationResult.flights[0].arrivalDate = flightStartDay.format('YYYY-MM-DDTHH:mm:ss');
            this.state.reservationRequest.valuationResult.flights[0].departureDate = flightStartDay.format('YYYY-MM-DDTHH:mm:ss');

            flightEndDay.add(this.state.reservationRequest.nights, 'days');
            this.state.reservationRequest.valuationResult.flights[1].arrivalDate = flightEndDay.format('YYYY-MM-DDTHH:mm:ss');
            this.state.reservationRequest.valuationResult.flights[1].departureDate = flightEndDay.format('YYYY-MM-DDTHH:mm:ss');
        }
        this.state.reservationRequest.holder = localStorage.getItem('holder') ? JSON.parse(localStorage.getItem('holder')) : {};
        this.state.reservationRequest.clientLocator = localStorage.getItem('clientLocator') ? localStorage.getItem('clientLocator') : '';
        this.state.reservationRequest.outboundFlight = {};
        this.state.reservationRequest.returnFlight = {};
        this.state.reservationRequest.clientObservation = localStorage.getItem('observations') ? JSON.parse(localStorage.getItem('observations')) : [];
        this.state.reservationRequest.cancellationInsuranceAcepted = false;
    }

    componentDidMount() {
        super.componentDidMount();
        window.scrollTo(0, 0);
        const { confirmPayment, errorForPayment, paymentHash, t } = this.props;
        if (confirmPayment) {
            this.fireReservation(confirmPayment, paymentHash);
        } else if (errorForPayment) {

            const { hotelCode, requestCode } = this.props;

            const redirect = () => {
                const paths = ['hotels', hotelCode, 'reserve', requestCode];
                window.location.href = /#/ + paths.join('/');

                alert(t('PAYMENTS_ERRORS.URL_KO'));
            };
            const reserva = this.state.reservationRequest;
            this.fireErrorPayment(paymentHash, reserva)
                .then(() => redirect())
                .catch(() => redirect());
        }
    }

    componentWillUnmount() {
        localStorage.removeItem('holder');
        localStorage.removeItem('clientLocator');
        localStorage.removeItem('cancellationInsuranceAcepted');
    }

    firePaymentToken = (secure3d, price) => {
        const { reservationRequest } = this.state;
        const valid = this.formValidations();

        if (!valid) {
            return;
        }

        const options = {
            description: 'Olympia',
            amount: Math.trunc((price * 100).toFixed(0)),
            urlOk: `${window.location.href}/payment-confirm?h={hash}`,
            urlKo: `${window.location.href}/payment-error?h={hash}`,
        };

        this.setState((prevState, props) => {
            return {
                hideIcon: true,
                processing: true,
                operationstatus: 'info',
                mode: 'indeterminate',
                operationtitle: this.props.t('CONFIRM_BOOKING.PLEASE_WAIT'),
                operationtext: ''
            };
        });
        return getPaymentToken([reservationRequest], options, secure3d)
            .then(({ token: iframeToken, merchantOperation }) => {
                window.scrollTo({
                    top: 0,
                    left: 0,
                    behavior: 'smooth'
                });
                this.props.dispatch(setObservations(this.getObservations()));
                this.setState(() => ({
                    iframeToken,
                    hideIcon: false,
                    merchantOperation,
                    processing: false
                }));

            })
            .catch((err) => {
                this.setState(() => ({
                    iframeToken: null,
                    hideIcon: false,
                    operationstatus: 'error',
                    operationtitle: this.props.t('CONFIRM_BOOKING.CONFIRMATION_ERROR'),
                    operationtext: err.message ? err.message : this.props.t('CONFIRM_BOOKING.CONFIRMATION_ERROR_MESSAGE') + '\n' + err.message,
                    mode: 'buffer',
                    completed: 100
                }));
            });
    }

    formValidations = () => {

        // if (this.state.formClientLocatorError) {
        //     alert(this.props.t(this.state.formClientLocatorErrorMessage));
        //     return false;
        // }
        if (this.state.formHolderError) {
            alert(this.props.t('CONFIRM_BOOKING.PLEASE_COMPLETE_CLIENT_DATA'));
            return false;
        }
        if (this.state.formDocumentError && this.state.reservationRequest.cancellationInsuranceAcepted) {
            if (this.state.formDocumentError === 'INCOMPLETE_DOCUMENT_TYPE') {
                alert(this.props.t('CONFIRM_BOOKING.INCOMPLETE_DOCUMENT_TYPE'));
                return false;
            }
            if (this.state.formDocumentError === 'INCOMPLETE_DOCUMENT') {
                alert(this.props.t('CONFIRM_BOOKING.INCOMPLETE_DOCUMENT'));
                return false;
            }
            if (this.state.formDocumentError === 'DOCUMENT_INVALID') {
                alert(this.props.t('CONFIRM_BOOKING.DOCUMENT_INVALID'));
                return false;
            }
        }
        if (this.state.formHolderError) {
            alert(this.props.t('CONFIRM_BOOKING.PLEASE_COMPLETE_CLIENT_DATA'));
            return false;
        }

        if (this.state.reservationRequest.valuationResult.flightDataRequired &&
            (!this.isValidFlight(this.state.reservationRequest.outboundFlight) ||
                !this.isValidFlight(this.state.reservationRequest.returnFlight))) {
            alert(this.props.t('CONFIRM_BOOKING.PLEASE_COMPLETE_FLIGHT_DATA'));
            return false;
        }

        return true;
    }

    fireErrorPayment = (paymentHash, reserva) => {

        this.setState((prevState, props) => {
            return { hideIcon: false, processing: true, operationstatus: 'info', mode: 'indeterminate' };
        });

        return errorPayment(paymentHash, reserva)
            .then((result) => {
                this.setState({ hideIcon: false, processing: false });
            })
            .catch((e) => {
                this.setState({ hideIcon: false, processing: false });
            });
    }

    fireReservation = (isConfirmPayment = false, hash) => {

        if (!isConfirmPayment) {
            const valid = this.formValidations();

            if (!valid) {
                return;
            }
        }

        this.setState((prevState, props) => {
            return { hideIcon: true, processing: true, operationstatus: 'info', mode: 'indeterminate' };
        });

        let reserva = this.state.reservationRequest;
        reserva.clientObservation = isConfirmPayment ? JSON.parse(localStorage.getItem('observations')) : this.getObservations();
        doReservation(reserva, isConfirmPayment, hash)
            .then(result => {
                localStorage.removeItem('holder');
                localStorage.removeItem('clientLocator');
                localStorage.removeItem('cancellationInsuranceAcepted');

                if(isConfirmPayment){
                    trackEvent('reservation_confirmed_payment', { reservation_code: result.reservationCode });
                } else{
                    trackEvent('reservation_confirmed', { reservation_code: result.reservationCode });
                }

                this.setState({ hideIcon: false, mode: 'buffer', processing: false, aceptoreservar: true, result: result });
                if (result.reservationCode) {
                    if (!isConfirmPayment) {
                        this.props.dispatch(setObservations(this.getObservations()));
                    }
                    this.setState({
                        hideIcon: false,
                        operationstatus: 'success',
                    }, () => { this.redirectToReservation(); });
                } else {
                    this.setState({
                        hideIcon: false,
                        operationstatus: 'error',
                        operationtitle: this.props.t('CONFIRM_BOOKING.CONFIRMATION_ERROR'),
                        operationtext: result
                            ? result.message
                            : this.props.t('CONFIRM_BOOKING.CONFIRMATION_ERROR_MESSAGE'),
                    });
                }
            })
            .catch(err => {
                const messageText = err.message ? err.message : this.props.t('CONFIRM_BOOKING.CONFIRMATION_ERROR_MESSAGE') + '\n' + err.message;
                localStorage.removeItem('holder');
                localStorage.removeItem('clientLocator');
                localStorage.removeItem('cancellationInsuranceAcepted');
                if (err.Type === 'unavailableError') {
                    this.setState({ hideIcon: false, processing: false });
                } else {
                    if (err && (err.type === 'REFUND_ERROR' || err.type === 'RESERVATION_ERROR')) {
                        this.setState({ hideIcon: false, processing: false });
                        alert(messageText);
                    } else {
                        this.setState({
                            operationstatus: 'error',
                            hideIcon: false,
                            operationtitle: this.props.t('CONFIRM_BOOKING.CONFIRMATION_ERROR'),
                            operationtext: messageText,
                            mode: 'buffer',
                            completed: 100
                        });
                    }
                }
            });
    };

    getObservations() {
        const { clientObservation, observationsChecks } = this.state;
        const { t } = this.props;
        let observationsChecked = observationsChecks.filter(check => !!check.checked);
        let observations = [];
        if (observationsChecked && observationsChecked.length) {
            observations = observationsChecked.map(checks => (
                { id: checks.value, description: t(checks.label) }
            ));
            observations.unshift({ id: 1, description: clientObservation && !Array.isArray(clientObservation) ? clientObservation : '' });
            return observations;
        } else {
            observations.unshift({ id: 1, description: clientObservation && !Array.isArray(clientObservation) ? clientObservation : '' });
            return observations;
        }
    }

    setClientLocator(value) {
        let resRequest = this.state.reservationRequest;
        try {
            resRequest.clientLocator = value;
            this.clientLocatorValidator.validate(resRequest.clientLocator);
            this.setState({
                reservationRequest: resRequest,
                formClientLocatorError: false,
                formClientLocatorErrorMessage: ''
            });
        } catch (error) {
            this.setState({
                reservationRequest: resRequest,
                formClientLocatorError: true,
                formClientLocatorErrorMessage: error.message
            });
        }
    }

    setHolder(prop, value) {
        let rr = this.state.reservationRequest;
        rr.holder[prop] = value;
        rr.formHolderError = this.validateHolder(rr.holder);
        if (rr && rr.cancellationInsurance && rr.cancellationInsurance.active === 'SI' && rr.cancellationInsuranceAcepted) {
            rr.formDocumentError = this.validateDocument(rr.holder);
        }
        this.setState(rr);
    }

    validateDocument(holder) {
        const documentTypeIsEmpty = !holder.documentType || holder.documentType === 'none';
        const documentIsEmpty = !holder.document || !String(holder.document).match(/^(?!\s*$).+/);
        const invalidDocument = !documentIsEmpty && !documentTypeIsEmpty ? !ValidateSpanishID(holder.document).valid || ValidateSpanishID(holder.document).type !== holder.documentType : true;

        if (documentTypeIsEmpty) {
            return 'INCOMPLETE_DOCUMENT_TYPE';
        }
        if (documentIsEmpty) {
            return 'INCOMPLETE_DOCUMENT';
        }
        if (invalidDocument && holder.documentType !== 'Pas') {
            return 'DOCUMENT_INVALID';
        }
        return false;
    }

    validateHolder(holder) {
        //que el nombre no este vacio
        let invalid = true;
        const firstNameIsNotEmpty = holder.name && String(holder.name).match(/^(?!\s*$).+/);
        let lastNameIsNotEmpty = holder.lastname && String(holder.lastname).match(/^(?!\s*$).+/);
        if (firstNameIsNotEmpty && lastNameIsNotEmpty) {
            invalid = false;
        }

        return invalid;
    }

    setObservations(value) {
        let rr = this.state.reservationRequest;
        rr.clientObservation = value;
        this.setState(rr);
    }

    clickSummary = event => {
        event.stopPropagation();
    };

    redirectToReservation() {
        if (this.state && this.state.result) {
            let paths = ['bookings', this.state.result.reservationCode, 'view?new=true'];
            window.location.href = /#/ + paths.join('/');
        }
    }

    setOutboundFlight(flight) {
        let rr = this.state.reservationRequest;
        rr.outboundFlight = flight;
        this.setState(rr);
    }

    setReturnFlight(flight) {
        let rr = this.state.reservationRequest;
        rr.returnFlight = flight;
        this.setState(rr);
    }

    isValidFlight(flight) {
        const {departureDate, arrivalDate} = flight;
        const entries = Object.entries(flight);
        const isFormCompleted = entries.length && entries.filter(e => e[1] === '').length === 0;
        let invalidDate = false;
        if (departureDate && arrivalDate && arrivalDate.isAfter(departureDate)) {   
            invalidDate = true;
        }
        return isFormCompleted && invalidDate;
    }

    onReserveClick = (onlinePay, price) => () => {
        const { secure3d } = onlinePay;
        localStorage.setItem('holder', JSON.stringify(this.state.reservationRequest.holder));
        localStorage.setItem('clientLocator', this.state.reservationRequest.clientLocator);
        localStorage.setItem('observations', JSON.stringify(this.getObservations()));
        return onlinePay.pay && price > 0.05 ? this.firePaymentToken(secure3d, price) : this.fireReservation(false, '');
    }

    onCancelAndBack = async () => {
        const { merchantOperation } = this.state;
        this.setState({ hideIcon: true, processing: true });
        localStorage.removeItem('holder');
        localStorage.removeItem('clientLocator');
        localStorage.removeItem('clientLocator');
        try {
            await cancelPaymentForReservation(merchantOperation);
            window.location.reload();
        } catch (error) {
            alert(error.message);
        } finally {
            this.setState({ processing: false });
        }
    }

    onChangeInsuranseCancellation = (value) => {
        let rr = this.state.reservationRequest;
        rr.cancellationInsuranceAcepted = value;
        this.setState(rr);
    }

    getPriceWithInsurance({ cancellationInsurance }, price) {
        return Number((price + Number(cancellationInsurance.price)).toFixed(2));
    }

    setObservationsChecks(check, value) {
        let checks = this.state.observationsChecks;
        const checkSelected = checks.find(val => val.value === Number(value));
        checkSelected.checked = !checkSelected.checked;
        this.setState({ observationsCheks: checks });
    }

    render() {

        const { classes, t, confirmPayment } = this.props;
        const { hotel, reservationRequest, iframeToken } = this.state;
        reservationRequest.cancellationInsurance = hotel && hotel.cancellationInsurance ? hotel.cancellationInsurance : null;
        const rooms = _get(reservationRequest, 'valuationResult.hotels[0].rooms', []);
        const onlinePay = _get(reservationRequest, 'valuationResult.hotels[0].onlinePay', {});
        const amountToPayWithCard = onlinePay ? onlinePay.payInsurance && reservationRequest.cancellationInsuranceAcepted ? onlinePay.amountWithInsurance : onlinePay.amount : 0;
        const amountToPayWithCardFormatted = currencyFormatter.format(amountToPayWithCard, { code: 'EUR' });

        return (
            <div className="cmsConfirmation">
                <div className="cmsContainer">
                    <div className={classes.root}>
                        <div className={classes.mainResultsContainer}>


                            <Grid container justify={'space-between'} alignItems={'stretch'} className={classes.gridContainer}>

                                <DoRender if={!iframeToken}>
                                    <Grid item xs={12}>
                                        <Paper>
                                            <HotelHeaderRender hotel={hotel} expanded={true} />
                                        </Paper>
                                    </Grid>
                                </DoRender>

                                <Grid item xs={12} className="cmsReservationData" style={{ height: iframeToken ? '50rem' : undefined }}>

                                    {this.state.processing ? (
                                        <InformationPanel
                                            hideIcon={this.state.hideIcon}
                                            type={this.state.operationstatus}
                                            title={this.state.operationtitle}
                                            onCancel={e => { this.setState({ hideIcon: false, processing: false }); }}
                                            text={this.state.operationtext}>
                                            <LinearProgress className="cmsProgressBar" value={this.state.completed} variant={this.state.mode} />
                                        </InformationPanel>
                                    ) : (
                                            ''
                                        )}

                                    <ReservationDetailsRender
                                        reservation={this.state.reservationRequest}
                                        cancellationInsurance={reservationRequest.cancellationInsurance}
                                        displayprice={false}
                                        iframeToken={iframeToken}
                                        onCheck={this.onChangeInsuranseCancellation}
                                    />

                                    <ReservationPricesRender
                                        reservation={this.state.reservationRequest}
                                        onlinePay={onlinePay}
                                        cancellationInsurance={reservationRequest.cancellationInsurance}
                                        cancellationInsuranceAcepted={reservationRequest.cancellationInsuranceAcepted}
                                        displayToolTip={this.accountName == 'b2bweberoski'}
                                        onlyShowPVP={!getValue(netPrice, this.accountName)}
                                    />
                                    <DoRender if={iframeToken}>
                                        <Grid item xs={12}>
                                            <Button
                                                disabled={this.state.processing}
                                                onClick={this.onCancelAndBack}>
                                                <DynIcon icon="KeyboardArrowLeft" />
                                                {t('CONFIRM_BOOKING.CANCEL_AND_BACK')}
                                            </Button>
                                        </Grid>
                                    </DoRender>

                                    <DoRender if={!iframeToken && !confirmPayment}>
                                        <ReservationHolderRender
                                            reservation={this.state.reservationRequest}
                                            checks={this.state.observationsChecks}
                                            clientLocatorError={this.state.formClientLocatorError}
                                            onChangeClientLocator={value => {
                                                this.setClientLocator(value);
                                            }}
                                            error={this.state.formHolderError}
                                            onChange={(value, type) => {
                                                this.setHolder(type, value);
                                            }}
                                            onChangeObservations={value => {
                                                this.setObservations(value);
                                            }}
                                            onCheckboxChange={(check, value) => {
                                                this.setObservationsChecks(check, value);
                                            }}
                                        />
                                        {/* <ObservationsChecksRender checks={this.state.observationsChecks} /> */}
                                    </DoRender>


                                    <DoRender if={!iframeToken && this.state.reservationRequest.valuationResult.flightDataRequired}>
                                        <ReservationFlightRender
                                            reservation={this.state.reservationRequest.valuationResult}
                                            setOutboundFlight={(value) => {
                                                this.setOutboundFlight(value);
                                            }}
                                            setReturnFlight={(value) => {
                                                this.setReturnFlight(value);
                                            }}
                                            showButtons={false}
                                        />
                                    </DoRender>


                                    {renderTOC(reservationRequest.valuationResult.cancelationTerms).length !== 0 &&
                                        <DoRender if={!iframeToken && !confirmPayment}>
                                            <Paper className={classes.paperFrame}>
                                                <Typography className={classes.bookingTitle}>
                                                    {t('CONFIRM_MODIFY_BOOKING.BOOKING_CONDITIONS')}
                                                </Typography>
                                                <Grid container>
                                                    <Grid item xs={12}>
                                                        <article>
                                                            {renderTOC(reservationRequest.valuationResult.cancelationTerms)}
                                                        </article>
                                                    </Grid>
                                                </Grid>
                                            </Paper>
                                        </DoRender>}
                                </Grid>

                                <DoRender if={iframeToken || !confirmPayment}>
                                    <Grid item xs={12} style={{ height: iframeToken ? '50rem' : undefined }}>
                                        <Paper className={classes.paper} style={{ height: '90%' }}>

                                            <DoRender if={iframeToken}>
                                                <Grid container style={{ height: '90%' }}>
                                                    <div class="CmsPaymentIframe"><p>{t('CONFIRM_MODIFY_BOOKING.PAYMENT_DATA')}</p></div>
                                                    <PaymentIframe token={iframeToken} style={{ height: '90%' }} t={t} />
                                                </Grid>
                                            </DoRender>

                                            <DoRender if={!iframeToken && !confirmPayment}>
                                                <Grid container>

                                                    {/* DETALLE CANCELACIONES  (si cancelas desde ...) */}
                                                    <Grid item xs={12}>
                                                        <div>
                                                            {rooms.map((room, id) => {
                                                                return room ? (
                                                                    <div>
                                                                        <Typography>
                                                                            {room.description}
                                                                        </Typography>
                                                                        <Typography component="ul">
                                                                            {renderCancellations(id,
                                                                                room.options[0].cancelations,
                                                                                this.state.B2bVerPVP,
                                                                                getValue(netPrice, this.currentUser.accountName.toLowerCase()),
                                                                                this.props)
                                                                            }
                                                                        </Typography>
                                                                    </div>
                                                                ) : (
                                                                        ''
                                                                    );
                                                            })}
                                                        </div>
                                                        <Typography>
                                                            {
                                                                t('CONFIRM_MODIFY_BOOKING.PRICE_CALCULATION_MESSAGE')
                                                            }
                                                        </Typography>
                                                    </Grid>


                                                    {/* BOTTOM BUTTON/CHECKBOX  */}
                                                    <DoRender if={!confirmPayment}>
                                                        <Grid item container xs={12}>
                                                            <Grid xs={8}>
                                                                <FormGroup row>
                                                                    <FormControlLabel
                                                                        control={
                                                                            <Checkbox
                                                                                checked={this.state.aceptoreservar}
                                                                                onChange={(event, value) => {
                                                                                    this.setState({ aceptoreservar: value });
                                                                                }}
                                                                                value="checkedA"
                                                                            />
                                                                        }
                                                                        label={t('CONFIRM_MODIFY_BOOKING.CANCELLATIONS_CONDITIONS_ACCEPT')}
                                                                    />
                                                                </FormGroup>
                                                            </Grid>
                                                            <Grid xs={4}>
                                                                <div className="button">
                                                                    <Button
                                                                        variant='raised'
                                                                        color='primary'
                                                                        disabled={!this.state.aceptoreservar}
                                                                        onClick={this.onReserveClick(onlinePay, amountToPayWithCard)}>
                                                                        {t('CONFIRM_BOOKING.BOOKING_BUTTON')}
                                                                    </Button>
                                                                </div>
                                                            </Grid>
                                                        </Grid>
                                                        <Grid item container xs={12} className="info-footer">
                                                            <Typography>
                                                                {this.state.reservationRequest && this.state.reservationRequest.cancellationInsuranceAcepted && reservationRequest.cancellationInsurance && reservationRequest.cancellationInsurance.active === 'SI' &&
                                                                    t('BOOKINGS.CANCELLATION_INSURANCE_INCLUDED')
                                                                }
                                                            </Typography>
                                                        </Grid>
                                                        <DoRender if={onlinePay && onlinePay.pay && amountToPayWithCard > 0.05}>
                                                            <Grid item xs={12} className="info-footer">
                                                                <Typography>
                                                                    {t('CONFIRM_BOOKING.PRICE_TO_PAY_WITH_CARD')}
                                                                    {amountToPayWithCardFormatted}
                                                                </Typography>
                                                            </Grid>
                                                        </DoRender>
                                                    </DoRender>
                                                </Grid>
                                            </DoRender>
                                        </Paper>
                                    </Grid>
                                </DoRender>
                            </Grid>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        observations: state.hotelsRedux.observations
    };
};

export default connect(mapStateToProps)(translate('translations')(withStyles(styles)(ReservationConfirmView)));



// WEBPACK FOOTER //
// ./src/components/Reservation/ReservationConfirmView.js